import React, { Component } from 'react';
import moment from 'moment';
import RoutingConstant from 'lib/RoutingConstants';

import { post } from 'lib/api';

class UserProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: this.props.name,
      servingSize:this.props.servingSize,
      recipeTypes: this.props.recipeTypes,
      // recipeValue: ''
      content: false,
      confirmMessage: '',
    };
  }

  // eslint-disable-next-line
  UNSAFE_componentWillReceiveProps(props) {
    this.setState({
      ...props,
      recipeTypes: props.recipeTypes,
    });
  }

  updateMealPlan() {
    const { mealPlan } = this.state
    const url = mealPlan ? RoutingConstant.updateMealData : RoutingConstant.mealPlanStyles;
    this.setState({ content: true });
    const  inputs = {}
    // const { inputs } = this.state;
    const { servingSize, recipeTypes } = this.state;
    inputs.default_serving_size = servingSize;
    inputs.recipes_with_meat = recipeTypes
    post(url, inputs).then((response) => {
      const confirmMessage = 'You have successfully update your ninja profile';
      localStorage.setItem('default_serving_size',inputs.default_serving_size);

      // eslint-disable-next-line
      this.setState({ content: false, response, confirmMessage });
    }).catch((err) => {
      // eslint-disable-next-line
      this.setState({ content: false, err });
    });
  }

  updateRChoice(recipeTypes) {
    this.setState({ recipeTypes })
  }

  message() {
    this.setState({ confirmMessage: '' });
  }

  render() {
    const { name, email, servingSize, content, confirmMessage, recipeTypes } = this.state;
    let { DOB } = this.state;
    if (DOB) {
      DOB = moment(DOB).format('DD / MM / YYYY');
    }
    const saveText = content === false ? 'Save Changes' : 'Saving...';
    
    return (
      <div className="dash-cntnt-dtail-hdr box-margin">
        <title> Prep Day - Profile </title>
        <div className="grocery-list-cntnt userProfile">
          <div className="row">
            <div className="col-md-12">
              <div className="top-section">
                <span> Your Profile </span>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
          
              <div className="login-sectn pass-reset-sectn password_section left_border">
                <div className="row">
                  <div className="col-md-10 form-row">
                    <label htmlFor="name"> Name: 
                      <span> {name} </span>
                    </label>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-10 form-row">
                    <label htmlFor="email"> Email: 
                      <span> {email} </span>
                    </label>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-10 form-row top-section deflt-srv-size">
                    <div className="col-md-9 form-row">
                      <label htmlFor="email"> Default Serving Size: </label>
                      <p className="text">How many people will you be cooking each recipe for?</p>
                    </div>
                    <div className="col-md-3 form-row">
                      <div className="btn-group bootstrap-select custm-selct mealplan-btn meal-day">
                        <select className="selectpicker show-tick form-control data-hj-whitelist" onChange={(e) => { this.setState({ servingSize: e.target.value }); }} value={servingSize}>
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="4">4</option>
                          <option value="5">5</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>


                <div className="row">
                  <div className="col-md-12 form-row" style={{"padding" : "0px"}}>
                    <label className="chs-rcp-type"> What types of recipes do you want to see? </label>
                    <div className="col-md-12">
                      <input
                        type="radio"
                        name="recipe"
                        checked={recipeTypes==="no"}
                        id="recipe"
                        onChange={()=>this.updateRChoice('no')}
                      />
                      <span className="radiomark1"/>
                      <span className="chs-rcp"> All Recipes </span>
                    </div>
                    <div className="col-md-12">
                      <input
                        type="radio"
                        checked={recipeTypes==="yes"}
                        name="recipe"
                        id="recipe1"
                        onChange={()=>this.updateRChoice('yes')}
                      />
                      <span className="radiomark1" />
                      <span className="chs-rcp"> Only non-meat recipes (vegan & vergetarian recipes) </span>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="form-row text-right col-md-8 margn">
                    <button
                      className="next-btn color sbmt-btn"
                      onClick={() => this.updateMealPlan()}
                      disabled={content}
                    >
                      {saveText}
                    </button>
                  </div>
                </div>
                  
                {confirmMessage !== '' &&
                  <div className="colr">
                    {confirmMessage}
                    <div style={{ display: 'none' }}> {setTimeout(() => this.message(), 3000)} </div>
                  </div>
                }
                
              </div>
            </div>
          </div>
        </div>
      </div>
      // </div>
    );
  }
}
export default UserProfile;



// WEBPACK FOOTER //
// ./src/components/Profile/UserProfile.js